@if (lahetysdata | async) {
  <div>
    <div class="blue-background">
      <div style="margin-left: auto; margin-right: auto">
        <div class="ylapalkki valkoinen">
          <app-button additionalClass="sulje" (click)="peruutaLahettaminen()" actionId="Peruuta laskun lähettäminen">
            <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
          </app-button>
          <div class="dropparit-container" style="width: 100%">
            <div class="dropparit">
              <app-button (click)="vaihdaValilehti(0)" styles="text-align: center; margin: 5px; padding: 5px; border-radius: 10px; font-weight: 100; font-size: 16px; min-width: 84.5px;" [dynamicClass]="{ selectedmenu: (aktiivinenValilehti | async) === 0 }" actionId="Vaihda laskun lähetyksen välilehti: sähköpostilla">
                <i class="icon ion-ios-at" style="font-size: 43px; height: 37px; display: inline-block; line-height: 37px; z-index: 1"></i>
                <br />
                {{ 'lasku.sposti-dialog.laheta-lasku-spostilla' | translate | async }}
              </app-button>
              <app-button (click)="vaihdaValilehti(1)" styles="text-align: center; margin: 5px; padding: 5px; border-radius: 10px; font-weight: 100; font-size: 16px; min-width: 84.5px;" [dynamicClass]="{ selectedmenu: (aktiivinenValilehti | async) === 1 }" actionId="Vaihda laskun lähetyksen välilehti: verkkolaskuna">
                <i class="icon ion-ios-flash" style="font-size: 43px; height: 37px; display: inline-block; line-height: 37px"></i>
                <br />
                {{ 'lasku.sposti-dialog.verkkolasku.laheta-verkkolaskuna' | translate | async }}
              </app-button>
              <button (click)="vaihdaValilehti(3)" disabled mat-button styles="text-align: center; margin: 5px; padding: 5px; border-radius: 10px; font-weight: 100; font-size: 16px; min-width: 84.5px;" [class.selectedmenu]="(aktiivinenValilehti | async) === 3">
                <i class="icon ion-ios-mail" style="font-size: 43px; height: 37px; display: inline-block; line-height: 37px"></i>
                <br />
                {{ 'lasku.sposti-dialog.paperi.laheta' | translate | async }}
              </button>
              <app-button (click)="vaihdaValilehti(2)" styles="text-align: center; margin: 5px; padding: 5px; border-radius: 10px; font-weight: 100; font-size: 16px; min-width: 84.5px;" [dynamicClass]="{ selectedmenu: (aktiivinenValilehti | async) === 2 }" actionId="Vaihda laskun lähetyksen  välilehti: lähetä itse">
                <i class="ion-ios-person" style="font-size: 43px; height: 37px; display: inline-block; line-height: 37px"></i>
                <br />
                {{ 'lasku.sposti-dialog.itse.laheta' | translate | async }}
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-laheta-lemonator [data]="lahetysdata | async" (laskuLahetettiin)="kasitteleLahetys($event)" [aktiivinenValilehti]="aktiivinenValilehti | async"></app-laheta-lemonator>
  </div>
}

@if (!(lahetysdata | async)) {
  <div class="detail-page">
    <app-asiakas-otsikko [otsikko]="otsikko" [naytaPalaa]="true" [paluuUrl]="paluuUrl" [asiakas]="asiakas"></app-asiakas-otsikko>
    @if (kirjanpitajaOnDevaajaObservable | async) {
      <div style="padding-bottom: 20px">
        <h3 style="margin: 0">Urit</h3>
        <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
          Lasku: <a [href]="laskuEncodedUriObservable | async" target="_BLANK">{{ laskuUriObservable | async }}</a>
        </div>
        <div style="padding-left: 1em; padding-right: 1em">
          Mahdollinen Kirjattava lasku: <a [href]="kirjattavalaskuEncodedUriObservable | async" target="_BLANK">{{ kirjattavalaskuUriObservable | async }}</a>
        </div>
        <div style="padding-left: 1em; padding-right: 1em">
          Mahdollinen hakemisto-lasku doc: <a [href]="hakemistoLaskuEncodedUriObservable | async" target="_BLANK">{{ hakemistoLaskuUriObservable | async }}</a>
        </div>
        <div style="padding-left: 1em; padding-right: 1em">
          Mahdollinen toistuva lasku: <a [href]="toistuvaLaskuEncodedUriObservable | async" target="_BLANK">{{ toistuvaLaskuUriObservable | async }}</a>
        </div>
      </div>
    }
    <div class="otsake-container">
      <!-- <button class="sulje light-blue-text" mat-button (click)="peruuta()" type="button">
              <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block;" class="icon ion-md-arrow-back"></i>
            </button> -->
      <div class="otsake">
        <!-- <div *ngIf="naytaKorvatunOtsake()">
              <span>{{'lasku.katsele-muokattava-dialog.lasku' | translate | async}}</span>
              <h2 class="light-blue-text">{{annaKorvatunOtsake()}}</h2>
            </div>
            <div *ngIf="naytaTavallinenOtsake()">
              <span>{{'lasku.katsele-muokattava-dialog.lasku' | translate | async}}</span>
              <h2 class="light-blue-text">{{laskuSharedService.annaMuotoiltuLaskunumero(kasiteltava)}} {{kasiteltava?.asiakas?.nimi}}</h2>
            </div> -->
        @if (naytaMaksuaikaa()) {
          <div>
            <span>{{ 'lasku.katsele-muokattava-dialog.maksuaikaa' | translate | async }}</span>
            <h2 [class.light-blue-text]="annaMaksuaikaa() > -1" [class.red-text]="annaMaksuaikaa() < 0">{{ annaMaksuaikaa() }} pv</h2>
          </div>
        }
        @if (naytaSumma()) {
          <div>
            <span>
              {{ 'lasku.tila.' + $safeNavigationMigration(juurilasku?.tila) | translate | async }}
            </span>
            @if (juurilasku?.tila == 'm' || juurilasku?.tila == 'ml') {
              <h2 [class.purple-text]="juurilasku?.tila == 'ml'" [class.green-text]="juurilasku?.tila == 'm'">{{ reskontraSummaObservable | async | lmoney: kasiteltava?.valuutta | async }}</h2>
            } @else {
              <h2 [class.blue-text]="vertaaYhtaSuuret($safeNavigationMigration(kasiteltava?.avoinna), $safeNavigationMigration(kasiteltava?.summa)) && juurilasku?.tila == 'a'" [class.red-text]="juurilasku?.tila == 'e'" [class.yellow-text]="vertaaEkaPienempiKuinToka(kasiteltava?.avoinna, kasiteltava?.summa) && vertaaEkaPienempiKuinToka(0, kasiteltava?.avoinna) && juurilasku?.tila == 'a'">
                {{ kasiteltava?.avoinna | lmoney: kasiteltava?.valuutta | async }}
              </h2>
            }
          </div>
        }
      </div>
    </div>
    <div class="nappula-container">
      <div class="nappulat">
        <!-- *ngIf="nakyvyystiedotObservable | async; as nakyvyystiedot" -->
        <div>
          <!-- <button mat-button class="secondarybutton" (click)="muokkaa()" *ngIf="nakyvyystiedot.onkoMuokkaaNakyvissa">{{'lasku.katsele-muokattava-dialog.muokkaa' | translate | async}}</button> -->
          <!-- <button mat-button class="secondarybutton" (click)="naytaMuokkausEstettyDialogi()" *ngIf="nakyvyystiedot.onkoMuokkaaInfoNakyvissa">{{'lasku.katsele-muokattava-dialog.muokkaa' | translate | async}}</button> -->
          <!-- <button mat-button class="secondarybutton" >
              <mat-icon>info</mat-icon>
            </button> -->
          <!-- <button mat-button class="secondarybutton" (click)="kopioiUusiLasku()" *ngIf="nakyvyystiedot.onkoKopioiUusiLaskuNakyvissa">{{'lasku.katsele-muokattava-dialog.kopioi-uusi-lasku' | translate | async}}</button>
            <button mat-button class="secondarybutton" (click)="poistaLuonnos()" *ngIf="nakyvyystiedot.onkoPoistoLuonnosNakyvissa">{{'lasku.katsele-muokattava-dialog.poista-luonnos' | translate | async}}</button> -->
          <!-- <button mat-button class="secondarybutton" (click)="hyvita()" *ngIf="nakyvyystiedot.onkoHyvitaNakyvissa">{{'lasku.katsele-muokattava-dialog.hyvita' | translate | async}}</button> -->
          @if (onkoLataaLaskuNakyvissa()) {
            <app-secondary-button (click)="lataaLasku()" actionId="Lataa laskun pdf koneelle">
              {{ 'lasku.katsele-muokattava-dialog.lataa-lasku' | translate | async }}
            </app-secondary-button>
          }
        </div>
        @if (kirjanpitajaOnDevaajaTaiTukiObservable | async) {
          <div>
            <app-secondary-button (click)="laskeReskontraUudelleen()" additionalClass="lasku-buttons" actionId="Laske laskun reskontra uudelleen">LASKE RESKONTRA, PÄIVITÄ TILA JA INDEKSOI UUDELLEEN</app-secondary-button>
          </div>
        }
        @if ((this.kirjanpitajaOnHallintoTaiLuottoObservable | async) && this.asiakas.avain === 'jzATU474P4BRCkEANZ1H') {
          <div>
            <div>
              @if (_naytaNappulat() && onkoHyvitaNakyvissa()) {
                <app-secondary-button (click)="hyvita()" additionalClass="lasku-buttons" actionId="Avasi uuden laskunäkymän: Hyvitä">{{ 'lasku.katsele-muokattava-dialog.hyvita' | translate | async }}</app-secondary-button>
              }
              @if (_naytaNappulat() && onkoMerkitseOsittainMaksetuksiNakyvissa()) {
                <app-secondary-button (click)="merkitseOsittainMaksetuksi()" additionalClass="lasku-buttons" actionId="Avasi dialogin: Merkitse maksetuksi">{{ 'lasku.katsele-muokattava-dialog.merkitse-osittain-maksetuksi' | translate | async }}</app-secondary-button>
              }
              @if (_naytaNappulat() && onkoMaksumuistutusNakyvissa()) {
                <app-secondary-button (click)="lahetaMuistutuslasku()" additionalClass="lasku-buttons" actionId="Avasi maksumuistutuksen lähetysnäkymän">{{ 'lasku.katsele-muokattava-dialog.laheta-maksumuistutus' | translate | async }}</app-secondary-button>
              }
              @if (_naytaNappulat() && onkoMaksumuistutusNakyvissa()) {
                <app-secondary-button (click)="lahetaPerintaritarimuistutuslaskuHallinto()" additionalClass="lasku-buttons" actionId="Lähetä muistutuslasku perintäritarille">{{ 'lasku.katsele-muokattava-dialog.laheta-maksumuistutus' | translate | async }} (Perintäritari) HALLINTO</app-secondary-button>
              }
              @if (_naytaNappulat() && onkoPeruutaLuottotappioMerkintaNakyvissa()) {
                <app-secondary-button (click)="peruutaLuottotappiomerkinta()" additionalClass="lasku-buttons" actionId="Peruuta luottotappiomerkintä">{{ 'lasku.katsele-muokattava-dialog.peruuta-merkitse-luottotappioksi' | translate | async }}</app-secondary-button>
              }
              @if (_naytaNappulat() && onkoMerkitseLuottotappioksiNakyvissa()) {
                <app-secondary-button (click)="merkitseLuottotappioksi()" additionalClass="lasku-buttons" actionId="Merkitse lasku luottotappioksi">{{ 'lasku.katsele-muokattava-dialog.merkitse-luottotappioksi' | translate | async }}</app-secondary-button>
              }
              @if (_naytaNappulat() && onkoPurkuunLiittyvatNakyvissa()) {
                <app-secondary-button (click)="lahetaPurkuViesti('purku_uhka_maksamattomat')" additionalClass="lasku-buttons" actionId="Avasi dialogin: Lähetä purku-uhka sähköposti (maksamattomat)">Lähetä purku-uhka</app-secondary-button>
              }
              @if (_naytaNappulat() && onkoPurkuunLiittyvatNakyvissa()) {
                <app-secondary-button (click)="lahetaPurkuViesti('purku_maksamattomat')" additionalClass="lasku-buttons" actionId="Avasi dialogin: Lähetä purku sähköposti (maksamattomat)">Lähetä purku</app-secondary-button>
              }
              <app-secondary-button (click)="lahetaUudelleen()" additionalClass="lasku-buttons" actionId="Lähetä lasku uudelleen">{{ 'lasku.katsele-muokattava-dialog.laheta-uudelleen' | translate | async }}</app-secondary-button>
              <app-secondary-button (click)="lahetaUudelleenEriTavalla()" additionalClass="lasku-buttons" actionId="Lähetä lasku uudelleen eri tavalla">{{ 'lasku.katsele-muokattava-dialog.laheta-uudelleen-eri-tavalla' | translate | async }}</app-secondary-button>
              <app-secondary-button (click)="lahetaHyvityslaskuUudelleenSahkopostiin()" additionalClass="lasku-buttons" actionId="Lähetä hyvityslasku uudelleen sähköpostiin">Lähetä hyvityslasku uudelleen sähköpostilla</app-secondary-button>
            </div>
          </div>
        }
        <app-primary-button (click)="navigoiAsiakkaaseen()" styles="margin-top: 15px;" actionId="Navigoi laskun asiakkaan tietoihin tästä">Asiakkaan tietoihin</app-primary-button>

        @if (naytaEpaonnistunutSahkoinen()) {
          <mat-card appearance="outlined" class="laheta-uudelleen">
            <mat-card-header>
              <mat-card-title>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.lahettaminen-epaonnistui' | translate | async }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <form novalidate>
                <mat-form-field>
                  <mat-label>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.valittaja' | translate | async }}</mat-label>
                  <mat-select [formField]="sahkoinenLomake.valittaja">
                    @for (operator of verkkolaskuoperaattorit; track operator?.tunnus) {
                      <mat-option [value]="operator.tunnus"> {{ operator.nimi }} ({{ operator.tunnus }}) </mat-option>
                    }
                  </mat-select>
                  @if (onkoVirhe(sahkoinenLomake.valittaja, 'required') && (sahkoinenLomake.valittaja().dirty() || sahkoinenLomake.valittaja().touched())) {
                    <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.valittaja.required' | translate | async }}</mat-error>
                  }
                </mat-form-field>

                <mat-form-field>
                  <mat-label>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.osoite' | translate | async }}</mat-label>
                  <input type="text" [formField]="sahkoinenLomake.osoite" matInput />
                  @if (peppolValidationObservable | async; as peppolMessage) {
                    <mat-hint>{{ peppolMessage.message }}</mat-hint>
                  } @else {
                    <mat-hint>{{ 'lasku.katsele-muokattava-dialog.sahkoinen.virheellinen-osoite' | translate | async }}</mat-hint>
                  }
                  @if (onkoVirhe(sahkoinenLomake.osoite, 'minLength') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                    <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.minlength' | translate | async }}</mat-error>
                  }
                  @if (onkoVirhe(sahkoinenLomake.osoite, 'required') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                    <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.required' | translate | async }}</mat-error>
                  }
                  @if (onkoVirhe(sahkoinenLomake.osoite, 'valittaja') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                    <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.valittaja' | translate | async }}</mat-error>
                  }
                </mat-form-field>

                <app-primary-button (click)="lahetaSahkoinenUudelleen()" actionId="Lähetä sähköinen lasku uudelleen">
                  {{ 'lasku.katsele-muokattava-dialog.uudelleen-lahetys' | translate | async }}
                </app-primary-button>
              </form>
            </mat-card-content>
          </mat-card>
          <div><b>Osoitekyselyn tiedot</b></div>
          <pre>{{ $safeNavigationMigration(kasiteltava?.sahkoinen?.latestAddressQueryReponse) | json }}</pre>
          <div><b>Lähetystiedot</b></div>
          <pre>{{ $safeNavigationMigration(kasiteltava?.sahkoinen?.latestSendResponse) | json }}</pre>
        }

        @if (naytaEpaonnistunutSposti()) {
          <mat-card appearance="outlined" class="laheta-uudelleen">
            <mat-card-header>
              <mat-card-title>{{ 'lasku.katsele-muokattava-dialog.spostien-lahettaminen-epaonnistui' | translate | async }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              @for (vastaanottaja of kasiteltava?.email?.vastaanottajat; track vastaanottaja; let i = $index) {
                <div>
                  @if (vastaanottaja.status == 3) {
                    <form novalidate>
                      <mat-form-field>
                        <mat-label>{{ 'lasku.katsele-muokattava-dialog.spostin-lahetysvirhe' | translate | async }}</mat-label>
                        <input type="text" [formField]="vastaanottajienLomake[i]" matInput />
                        <mat-error>{{ 'lasku.katsele-muokattava-dialog.virheellinen-sahkoposti' | translate | async }}</mat-error>
                        <mat-hint align="start">{{ 'lasku.katsele-muokattava-dialog.tekninen-virhe' | translate | async }}: {{ vastaanottaja.viesti?.Description }} </mat-hint>
                      </mat-form-field>

                      <app-secondary-button (click)="naytaKokoVirhe(vastaanottaja)" actionId="Avasi laskun virhe dialogin">
                        {{ 'lasku.katsele-muokattava-dialog.koko-virheen-naytto' | translate | async }}
                      </app-secondary-button>
                      <app-primary-button (click)="lahetaEmailUudelleen($any(vastaanottaja))" actionId="Lähetä laskun email uudelleen">
                        {{ 'lasku.katsele-muokattava-dialog.uudelleen-lahetys' | translate | async }}
                      </app-primary-button>
                    </form>
                  }
                </div>
              }
            </mat-card-content>
          </mat-card>
        }
      </div>
    </div>
    <div style="max-width: 695px; width: 100%; margin-bottom: 25px">
      <lasku-pdf-esikatselu-perinteinen [tiedot]="esikatselutiedot"></lasku-pdf-esikatselu-perinteinen>
    </div>
    @if (kasiteltava?.liitteet && kasiteltava?.liitteet?.length > 0) {
      <div>
        <div class="light-blue-text" style="font-size: 1rem; margin-top: 40px; margin-bottom: 10px">Liitetiedostot</div>
        <mat-chip-listbox>
          @for (liite of kasiteltava?.liitteet; track liite) {
            <mat-chip-option style="cursor: pointer" (click)="lataaLiitetiedosto(liite)" [selectable]="false">
              {{ liite.nimi }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>
    }
    <div style="color: rgb(114, 115, 115); font-size: 12px">
      <div class="light-blue-text" style="font-size: 16px; margin-top: 40px; margin-bottom: 10px">{{ 'lasku.tapahtumaloki.otsikko' | translate | async }}</div>
      @if (lokitietojaLadataanObservable | async) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @for (loki of lokitiedotObservable | async; track loki) {
        <div (click)="naytaLoki(loki)" style="cursor: pointer">{{ loki.loki.pvm | ltimestamptime | async }}, {{ loki.tekija }}: {{ loki.viesti }}</div>
      }
    </div>
    <!-- <div style="color: rgb(114,115,115); font-size: 12px;">
    <div class="light-blue-text" style="font-size: 16px; margin-top: 40px; margin-bottom: 10px;">
      {{ 'lasku.reskontra.otsikko' | translate | async }}
      Reskontrahistoria laskussa (Tarkemmat tiedot klikkaamalla)
    </div>
    <div *ngFor="let merkinta of juurilasku?.reskontra" (click)="naytaMerkinta(merkinta)" style="cursor: pointer;">
      {{ merkinta.pvm | ltimestamp | async }}: {{ merkinta.suoritus | lmoney: kasiteltava?.valuutta | async }}
    </div>
  </div> -->
    <div style="color: rgb(114, 115, 115); font-size: 12px">
      <div class="light-blue-text" style="font-size: 16px; margin-top: 40px; margin-bottom: 10px">
        <!-- {{ 'lasku.reskontra.otsikko' | translate | async }} -->
        Erillinen reskontrahistoria (Tarkemmat tiedot klikkaamalla)
      </div>
      @if (reskontraaLadataanObservable | async) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @for (merkinta of reskontraLokiObservable | async; track merkinta) {
        <div (click)="naytaMerkinta(merkinta.data)" style="cursor: pointer">
          {{ merkinta.teksti }}
        </div>
      }
    </div>
  </div>
}
